// @flow
import type { ComponentType } from 'react';
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import routes from '../routes';
import { AuthConsumer } from '../context/auth';

type Props = {
  Component: ComponentType<any>,
  ispublic: boolean,
  keeponpublic?: boolean,
  custom?: any,
  match?: any,
};

const forceProfileIfNoTermsAccepted = false;

const AppRoute = (props: Props) => {
  const { ispublic, Component, keeponpublic, custom, ...rest } = props;
  return (
    <AuthConsumer>
      {({ isAuthenticated, user }) => {
        const canAccess = ispublic ? (keeponpublic || !isAuthenticated) : isAuthenticated;
        return (
          <Route
            {...rest}
            render={props => {
              if (forceProfileIfNoTermsAccepted && props.match.path !== routes.profile && !!user && !user.hasTerms) {
                return <Redirect to={routes.profile}/>;
              }
              if (canAccess) {
                const data = {
                  ...props,
                  ...custom,
                };
                return <Component {...data} />;
              }
              return <Redirect to={isAuthenticated ? routes.home : '/'}/>;
            }}
          />
        );
      }}
    </AuthConsumer>
  );
};

AppRoute.defaultProps = {
  ispublic: false,
};

export default AppRoute;
